export default {
    props: {
        borderColor: {
            type: String,
            default: undefined,
            kComposite: 'border.color'
        }, 
        borderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'border.width'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-barcodes-vue-wrapper/src/KendoQRCode/Border.js